// [<displayName>, <name (image file name)>]

export const bamboohr = ['BambooHR', 'bamboohr'];
export const expensify = ['Expensify', 'expensify'];
export const facebook = ['Facebook', 'facebook'];
export const freeagent = ['FreeAgent', 'freeagent'];
export const freshbooks = ['Freshbooks', 'freshbooks'];
export const googleAnalytics = ['Google Analytics', 'google-analytics'];
export const googleWorkspace = ['Google Workspace', 'google-workspace'];
export const instagram = ['Instagram', 'instagram'];
export const justlogin = ['JustLogin', 'justlogin'];
export const linkedin = ['LinkedIn', 'linkedin'];
export const mailchimp = ['Mailchimp', 'mailchimp'];
export const myob = ['MYOB Account Right', 'myob'];
export const quickbooks = ['Quickbooks', 'quickbooks'];
export const run = ['RUN', 'run'];
export const sage = ['Sage', 'sage'];
export const shopify = ['Shopify', 'shopify'];
export const talenox = ['Talenox', 'talenox'];
export const unleashed = ['Unleashed', 'unleashed'];
export const vend = ['Vend', 'vend'];
export const visa = ['Visa', 'visa'];
export const wave = ['Wave', 'wave'];
export const xero = ['Xero', 'xero'];
export const zoho = ['Zoho', 'zoho'];
